module.exports = __webpack_public_path__ + "static/devil_shape1-1865ce9096b895502cf6c84e0c40c90a.png";